import React, {
    Fragment,
    useEffect,
    useState,
} from 'react';
import { User } from 'oidc-client-ts';
import { Navigate, useLocation } from 'react-router-dom';

import { useAppSelector } from '../state/hooks';
import AuthService from '../services/authService';
import { hasNetworkInsightsRole } from '../utils/environmentUtils';
import { publicRoutes } from './appRouteList';
import { ApiStatus } from '../utils/enums';

const AuthenticatedRoute = ({
    children,
}: {
    children: React.JSX.Element;
}): React.JSX.Element => {
    const location = useLocation();

    const [user, setUser] = useState<User | null>(null);
    const [recievedUserData, setRecievedUserData] = useState(false);

    const userLoginStatus = useAppSelector((state) => { return state.user.userLoginStatus; });
    const userDetails = useAppSelector((state) => { return state.user.userDetails; });

    const hasAppPermission = hasNetworkInsightsRole({ userLoginStatus, userDetails });

    useEffect((): void => {
        (async (): Promise<void> => {
            try {
                const authenticatedUser = await AuthService.getUser();
                if (authenticatedUser !== null) {
                    setUser(authenticatedUser);
                }
            } finally {
                setRecievedUserData(true);
            }
        })();
    }, [children]);

    if (recievedUserData === true && user !== null && userLoginStatus === ApiStatus.Success && hasAppPermission) {
        return children;
    }

    if (recievedUserData === true && user !== null && userLoginStatus === ApiStatus.Success && hasAppPermission === false) {
        return (
            <Navigate
                to={publicRoutes.notAuthorized}
                state={{
                    from: location,
                }}
            />
        );
    }

    if (recievedUserData === true) {
        return (
            <Navigate
                to={publicRoutes.root}
                state={{
                    from: location,
                }}
            />
        );
    }

    return <Fragment />;
};

export default AuthenticatedRoute;
